"use client";

import { useChat } from "@/providers/chat-provider";
import { useStore } from "@/providers/global-store-provider";
import { MessageCircleIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const ChatBubble = () => {
	const { showChatWidget, handleOpenChatWidget } = useChat();
	const { numberOfUnreadChats: defaultNumberOfUnreadChats } = useStore();
	const pathname = usePathname();
	const [numberOfUnreadChats, setNumberOfUnreadChats] = useState(defaultNumberOfUnreadChats);

	useEffect(() => {
		setNumberOfUnreadChats(defaultNumberOfUnreadChats);
	}, [defaultNumberOfUnreadChats]);

	if (pathname === "/communities/bim-digital-twin/home") {
		return null;
	}

	if (pathname === "/communities/global-proptech-founders/home") {
		return null;
	}

	if (pathname === "/communities/brokers-agents/home") {
		return null;
	}

	return !showChatWidget ? (
		<button
			type="button"
			aria-label="Open Chat Inbox"
			onClick={handleOpenChatWidget}
			className="fixed bottom-16 right-4 rounded-full bg-brand-primary p-4 text-white opacity-90 shadow hover:opacity-100 hover:shadow-lg md:bottom-4"
		>
			<div className="relative">
				{/* NOTE: Temporarily disabling lottie animations */}
				{/* <Lottie
					animationData={glitterAnimation}
					loop={true}
					className="absolute bottom-0 right-0 h-20 w-20"
				/> */}

				{numberOfUnreadChats > 0 && (
					<div className="absolute -right-4 -top-4 h-6 w-6 rounded-full bg-red-600 p-1 text-xs font-semibold">
						{numberOfUnreadChats}
					</div>
				)}

				<MessageCircleIcon className="h-6 w-6 md:h-7 md:w-7" />
			</div>

			<span className="sr-only">Open Chat Inbox</span>
		</button>
	) : null;
};

export default ChatBubble;
